<script lang="ts">
	import Button from '$lib/components/Button/Button.svelte';
	import { _ } from 'svelte-i18n';
	import { getHubStores } from '$lib/stores/hubStores';

	export let isAUXModalRendered: boolean;

	const { hub } = getHubStores();
</script>

<div class="accountUnlocked">
	<div class="title">{$_('hubs.newsletters.unsubscribed')}</div>

	<div class="heading">
		{$_('hubs.callback.unsubscribed.message', { values: { hubName: $hub.name } })}
	</div>

	<Button on:click={() => (isAUXModalRendered = false)}>{$_('common.ok')}</Button>
</div>

<style>
	.accountUnlocked {
		display: flex;
		box-sizing: content-box;
		flex-direction: column;
		align-items: center;
		block-size: 30vh;
		max-block-size: calc(100vh - 60px);
		inline-size: 300px;
		padding: 50px;
	}

	.title {
		font-size: var(--fontSizeLarge);
	}

	.heading {
		margin-block: var(--gutterLarge);
		margin-inline: 0;
		color: var(--BLACK);
		font-size: var(--fontSizeNormal);
		font-weight: 500;
		text-align: center;
	}

	@media screen and (max-width: 575px) {
		.accountUnlocked {
			padding: 0;
			padding-block-start: 50px;
		}
	}
</style>
